import { Input } from "components/atoms/text-input";
import { Checkbox } from "components/atoms/checkbox";

export const FieldMapping = {
  text: Input,
  email: Input,
  password: Input,
  checkbox: Checkbox,
};
